/**
 * Utility functions for handling markdown content
 */

/**
 * Cleans markdown data by removing array wrapper syntax and normalizing newlines
 * @param data - The markdown string to clean
 * @returns Cleaned markdown string
 */
export const getCleanMarkdownData = (data: string): string => {
  let cleaned = data.trim();

  // Remove array wrapper syntax like ["..."] or ['...']
  if (
    (cleaned.startsWith('["') && cleaned.endsWith('"]')) ||
    (cleaned.startsWith("['") && cleaned.endsWith("']"))
  ) {
    cleaned = cleaned.slice(2, -2);
  }

  // Replace escaped newlines with markdown line breaks
  cleaned = cleaned.replace(/\\n/g, '  \n');

  return cleaned;
};
